var React = require('react');

function IconGoogle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M133.3-.1H10.6C4.8-.1 0 4.6 0 10.3v123.2c0 5.7 4.8 10.4 10.6 10.4h122.7c5.9 0 10.7-4.7 10.7-10.4V10.3c0-5.7-4.8-10.4-10.7-10.4z","fill":"#FFF","key":0}),React.createElement("path",{"d":"M113.5 73c0-3.1-.3-6-.8-8.8H72v16.7h23.2c-1 5.4-4 10-8.6 13v10.8h14c8.2-7.5 12.9-18.6 12.9-31.7z","fill":"#557EBF","key":1}),React.createElement("path",{"d":"M72 115.2c11.7 0 21.4-3.9 28.6-10.5l-14-10.8C82.8 96.5 77.8 98 72 98c-11.3 0-20.8-7.6-24.2-17.8H33.4v11.2c7.1 14.1 21.7 23.8 38.6 23.8z","fill":"#36A852","key":2}),React.createElement("path",{"d":"M47.8 80.2c-.9-2.6-1.4-5.4-1.4-8.2 0-2.8.5-5.6 1.4-8.2V52.6H33.4C30.5 58.4 28.8 65 28.8 72s1.7 13.6 4.6 19.4l14.4-11.2z","fill":"#F9BC15","key":3}),React.createElement("path",{"d":"M72 46c6.3 0 12 2.2 16.5 6.5L100.9 40C93.4 33 83.6 28.7 72 28.7c-16.9 0-31.5 9.7-38.6 23.8l14.4 11.2C51.2 53.6 60.8 46 72 46z","fill":"#EA4535","key":4})]);
}

IconGoogle.defaultProps = {"className":"icon google","viewBox":"0 0 144 143.9"};

module.exports = IconGoogle;

IconGoogle.default = IconGoogle;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-google.svg
// module id = 529
// module chunks = 0